export enum TransferStatus {
  NUEVO = 'Nuevo',
  FINALIZADO = 'Finalizado',
  POR_APROBAR = 'Por aprobar',
  APROBADO = 'Aprobado',
  RECHAZADO = 'Rechazado / anulado',
  ANULADO = 'Anulado',
  POR_REGISTRAR = 'Por registrar',
}

export enum TransferManageStatus {
  APROBADO = 'Recibido',
  RECHAZADO = 'Rechazado'
}